//
// A fluxible store that contains style attribute data for a brief.
//

import { BaseStore } from 'fluxible/addons';
import Immutable from 'immutable';

class BriefAttributeStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.attributeValues = new Immutable.Map({});
        this.attributeLabels = [];
    }

    buildAttributeValues(styleAttributes, attributeLabels) {
        let attributeValues = {};

        attributeLabels.forEach((label) => {
            let key = `${label[0]}_${label[1]}`;
            let value = styleAttributes && styleAttributes[key] ? styleAttributes[key] : 0;

            attributeValues[key] = value;
        });

        return attributeValues;
    }

    load(payload) {
        if (payload.attribute_labels) {
            this.attributeValues = new Immutable.Map(
                this.buildAttributeValues(payload.body.style_attributes, payload.attribute_labels)
            );
            this.attributeLabels = payload.attribute_labels || [];
            this.emitChange();
        }
    }

    updateAttributes(payload) {
        this.attributeValues = new Immutable.Map(payload.body.style_attributes || {});
        this.emitChange();
    }

    setSliderValue(payload) {
        this.attributeValues = this.attributeValues.set(payload.slider, payload.value);
        this.emitChange();
    }

    getState() {
        return {
            attributeValues: this.attributeValues,
            attributes: this.attributeLabels
        };
    }
}

BriefAttributeStore.storeName = 'BriefAttributeStore';
BriefAttributeStore.handlers = {
    SAVE_DRAFT_SUCCESS: 'updateAttributes',
    LOAD_DRAFT_DATA: 'load'
};

export default BriefAttributeStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefAttributeStore.js